import { useState } from "react";
import { Loading } from "components/assets/Icons";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import styles from "./Modals.module.scss";
import DropdownMenu from "../AddPage/components/DropdownMenu";
import userProfile from "services/user.profile";
import { dataBreaks } from "./dataBreaks";

export const ModalAddWorkTimeForecasting = ({
  setShowModal,
  setInfoMessage,
  setShowInfoMessage,
  setTypeOfMessage,
}) => {
  const [selectedStartMin, setSelectedStartMin] = useState("");
  const [selectedStartMax, setSelectedStartMax] = useState("");
  const [selectedEndMin, setSelectedEndMin] = useState("");
  const [selectedEndMax, setSelectedEndMax] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const newWorkTimeForecasting = {
      start_early: selectedStartMin,
      start_late: selectedStartMax,
      end_early: selectedEndMin,
      end_late: selectedEndMax,
    };

    const addNewWorkTimeForecasting = async (newWorkTimeForecasting) => {
      try {
        const response = await userProfile.addWorkTimeForecasting(newWorkTimeForecasting);

        if (response.status === 201) {
          setTypeOfMessage("success");
          setInfoMessage("Work Time Forecasting added successfully");
          setTimeout(() => setShowInfoMessage(true), 900);
          setTimeout(() => setShowInfoMessage(false), 2900);
        }
      } catch (error) {
        console.error("error >>:", error);
      } finally {
        setLoading(false);
      }
    };

    addNewWorkTimeForecasting(newWorkTimeForecasting);

    setTimeout(() => setShowModal(false), 500);
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>Add Work Time Forecasting</h2>
      <form className={styles.form} action="submit" onSubmit={handleOnSubmit}>
        <div className={styles.modalAddWorkTimeForecasting}>
          <h3 className={styles.title}>Start (mins)</h3>
          <div className={styles.start}>
            <DropdownMenu
              className={styles.early}
              fieldName={"startMin"}
              labelText={"Min"}
              data={dataBreaks}
              selectedStartMin={selectedStartMin}
              setSelectedStartMin={setSelectedStartMin}
            />
            <DropdownMenu
              className={styles.late}
              fieldName={"startMax"}
              labelText={"Max"}
              data={dataBreaks}
              selectedStartMax={selectedStartMax}
              setSelectedStartMax={setSelectedStartMax}
            />
          </div>
        </div>
        <div className={styles.modalAddWorkTimeForecasting}>
          {" "}
          <h3 className={styles.title}>End (mins)</h3>
          <div className={styles.end}>
            <DropdownMenu
              className={styles.early}
              fieldName={"endMin"}
              labelText={"Early"}
              data={dataBreaks}
              selectedEndMin={selectedEndMin}
              setSelectedEndMin={setSelectedEndMin}
            />
            <DropdownMenu
              className={styles.late}
              fieldName={"endMax"}
              labelText={"Late"}
              data={dataBreaks}
              selectedEndMax={selectedEndMax}
              setSelectedEndMax={setSelectedEndMax}
            />
          </div>
        </div>

        <div className={styles.group}>
          <Button
            size={VIEW.MIDDLE}
            color={COLOR.LIGHT}
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button size={VIEW.MIDDLE} type="submit">
            {loading ? <Loading /> : "Save"}
          </Button>
        </div>
      </form>
    </div>
  );
};
